module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	fox.registerWidget('Mixin_DocumentWidget', {
		configure: function(options) {
			this.registerOptions('', {
				closeOtherPopups: false,
				'embed.widget': '@root'
			});

			this.callParent('configure', arguments);
		},

		isActive: function() {
			return this._active;
		},

		embed: function() {},

		show: function(data) {
			fox.each(fox.wom.select('~.Mixin_DocumentWidget'), function(w) {
				if (w.getId() != this.getId()) {
					w.hide();
				}
			}, this);
			
			if (!this._indom) {
				this.afterEmbed();
			}

			this.dispatchEvent('show', data);
		},
		
		hide: function() {
			this.dispatchEvent('hide');
		},

		deactivate: function() {
			this.hide();
		},

		isOpen: function () {
			return $(this.element).is(':visible');
		}
	});

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/mixin/documentwidget.js
// module id = 209
// module chunks = 0